import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { messager, isUndef, setCustomUrlHook } from "./utils";
import { default as MAdapter } from "../plugins/base/BaseAdapter";
import conf from "./conf";
export var NativeConstructor = /*#__PURE__*/function () {
  function NativeConstructor() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, NativeConstructor);
    /**
     * 当前平台实例化的adapter的platform
     */
    _defineProperty(this, "currentPlatform", void 0);
    /**
     * 存储当前平台实例化的adapter
     */
    _defineProperty(this, "plugin", void 0);
    /**
     * 存储所有注册的adapter
     */
    _defineProperty(this, "pluginsMap", void 0);
    // LogGreen('******\n提示：\n 欢迎使用 native-adapter 5.x版本 \n******\n')
    this.plugin = '';
    this._zz_native_ = true;
    this.currentPlatform = {
      rule: function rule() {
        return false;
      },
      name: 'm'
    };
    this.config = _objectSpread(_objectSpread({}, window.nativeAdapterConfig), options);
    this.pluginsMap = {
      MAdapter: MAdapter
    };
    this.init();
    this.adapter = this.plugin;
    this.schema = this.getScheme();
    this.client = this.getClient();
  }
  _createClass(NativeConstructor, [{
    key: "init",
    value: function init() {
      this.applyPlugin();
    }
  }, {
    key: "instanceGenerator",
    value: function instanceGenerator(instanceArr) {
      var _this = this;
      instanceArr = instanceArr.filter(function (m) {
        return !_this[m];
      });
      Object.defineProperties(this, instanceArr.reduce(function (obj, method) {
        return obj[method] = {
          get: function get() {
            var _this2 = this;
            return function () {
              for (var _len = arguments.length, argv = new Array(_len), _key = 0; _key < _len; _key++) {
                argv[_key] = arguments[_key];
              }
              return _this2.plugin._invoke(method, argv);
            };
          }
        }, obj;
      }, {}));
    }
  }, {
    key: "applyPlugin",
    value: function applyPlugin() {
      var _this3 = this;
      NativeConstructor.plugins.forEach(function (item) {
        return _this3.pluginsMap[item.name] = item.ctor;
      });
      Object.keys(this.pluginsMap).forEach(function (key) {
        var Ctor = _this3.pluginsMap[key];
        var currentPlatform = _this3.getCurrentPlatform(Ctor.platform);
        if (currentPlatform) {
          // 实例化plugin时会注入当前this,即native实例
          _this3.plugin = new Ctor(_this3);
          _this3.currentPlatform = currentPlatform;
        }
      });
      // plugins没有匹配到平台、默认匹配baseAdapter
      if (!this.plugin) {
        var currentPlatform = this.getCurrentPlatform(MAdapter.platform);
        if (currentPlatform) {
          this.currentPlatform = currentPlatform;
        }
        this.plugin = new MAdapter(this);
      }
      this.instanceGenerator(conf.instance);
    }
  }, {
    key: "getCurrentPlatform",
    value: function getCurrentPlatform(platform) {
      return platform.filter(function (ruleItem) {
        return ruleItem.rule.test ? ruleItem.rule.test(navigator.userAgent) : ruleItem.rule();
      }).pop();
    }
  }, {
    key: "_setCustomUrlHook",
    value: function _setCustomUrlHook(f) {
      setCustomUrlHook(f);
    }
  }, {
    key: "on",
    value: function on(adaterMethodName, cb) {
      messager.$on(adaterMethodName, cb);
    }
  }, {
    key: "ready",
    value: function ready(cb) {
      if (this.plugin.__loaded) return cb ? cb() : true;
      messager.$on('ready', cb);
    }
  }, {
    key: "getUid",
    value: function getUid() {
      return this.plugin.getUid();
    }
  }, {
    key: "getClient",
    value: function getClient() {
      return this.currentPlatform.name;
    }
  }, {
    key: "getScheme",
    value: function getScheme() {
      return this.currentPlatform.scheme || '';
    }
  }, {
    key: "in",
    value: function _in(channel, cb) {
      typeof channel === 'string' && (channel = [channel]);
      // 替换数组中的wa为miniprogram
      channel = channel.map(function (item) {
        if (item === 'wa') return 'miniprogram';
        return item;
      });
      if (~channel.indexOf(this.currentPlatform.name)) {
        return cb ? cb() : true;
      }
      return false;
    }
  }, {
    key: "inWx",
    value: function inWx(cb) {
      if (this.currentPlatform.name === 'miniprogram' || this.currentPlatform.name === 'wechat') {
        return typeof cb === 'function' ? cb() : true;
      }
    }
  }, {
    key: "isLogin",
    value: function isLogin() {
      return this.plugin ? this.plugin.isLogin() : false;
    }
  }, {
    key: "getFormatPPU",
    value: function getFormatPPU() {
      return this.plugin.getFormatPPU();
    }
  }, {
    key: "replaceDomain",
    value: function replaceDomain(originUrl) {
      return this.plugin.replaceDomain(originUrl);
    }
  }, {
    key: "wrap",
    value: function wrap(method) {
      var _this4 = this;
      return function () {
        for (var _len2 = arguments.length, argv = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          argv[_key2] = arguments[_key2];
        }
        return _this4.plugin._invoke(method, argv);
      };
    }
  }, {
    key: "canIUse",
    value: function canIUse(method, obj) {
      if (obj && obj.isAdapter) {
        return !!this.adapter[method];
      }
      return !!(this.adapter[method] || this.adapter.__sdk && this.adapter.__sdk[method]);
    }
  }, {
    key: "hotFix",
    value: function hotFix(options) {
      var extend = Object.assign;
      var platform = options.platform,
        methods = options.methods;
      if (this.currentPlatform.name != platform) return;
      console.warn(Object.keys(methods));
      console.warn('当前页面含有hotfix插件，可能会有紧急上线的情况，请联系adapter维护者进行修复');
      extend(this.plugin.constructor.prototype, methods);
    }
  }, {
    key: "disableGlobalVars",
    value: function disableGlobalVars() {}
  }], [{
    key: "use",
    value: function use(ctor) {
      var name = ctor.pluginName;
      var installed = NativeConstructor.plugins.some(function (plugin) {
        return ctor === plugin.ctor;
      });
      if (installed) return NativeConstructor;
      if (isUndef(name)) {
        console.warn("\u63D2\u4EF6\u5FC5\u987B\u6709\u4E00\u4E2A\u9759\u6001pluginName\u5B57\u6BB5");
        return NativeConstructor;
      }
      NativeConstructor.plugins.push({
        name: name,
        ctor: ctor
      });
      return NativeConstructor;
    }
  }]);
  return NativeConstructor;
}();
_defineProperty(NativeConstructor, "plugins", []);
_defineProperty(NativeConstructor, "pluginsMap", {});
export function createNative(options) {
  var nadapter = new NativeConstructor(options);
  return nadapter;
}
export var Native = createNative;
createNative.use = NativeConstructor.use;